import { Flex, Spinner } from "@chakra-ui/react";

export function LoadingSpinner() {
  return (
    <Flex width="100%" height="800px" alignItems="center" justifyContent="center">
      <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="bij12_1.700" size="xl" />
    </Flex>
  );
}
